import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import useGetAssetsList from '@hooks/FixedAssets/useGetAssetsList';
import Add from './AddAssets';
import NtxTable from '@components/DataTable/NtxTable';

const Index = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  const { AssetsList: data, loading, error } = useGetAssetsList();

  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('رقم الأصل'), key: 'num' },
    { title: t('الرقم التسلسلي'), key: 'num2' },
    { title: t('النوع'), key: 'type' },
    { title: t('فئة الأصل'), key: 'cat' },
    { title: t('وحدة التشغيـل'), key: 'org' },

    { title: '', key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map(item => {
    let rowClass;

    // تحديد الشارة بناءً على القيمة
    let typeBadge;
    if (item.ownedLeased === 'OWNED') {
      typeBadge = (
        <span className='badge bg-success'>
          <i className='fas fa-home me-1'></i> {t('مملوك')}
        </span>
      );
    } else if (item.ownedLeased === 'LEASED') {
      typeBadge = (
        <span className='badge bg-primary'>
          <i className='fas fa-file-contract me-1'></i> {t('مستأجر')}
        </span>
      );
    } else {
      typeBadge = <span className='badge bg-secondary'>{t('غير محدد')}</span>;
    }

    return {
      name: i18n.language === 'en' ? item.name : item.name2,

      age: item.lifeInMonths,
      num: item.assetNumber,
      num2: item.serialNumber,
      type: typeBadge,
      cat: i18n.language === 'en' ? item.categoryName || 'Main Category' : item.categoryName2 || 'فئة رئيسية',
      org: i18n.language === 'en' ? item.organizationName : item.organizationName2,

      action: (
        <div>
          {/* زر التعديل */}
          <button
            type='button'
            className='btn  btn-outline-theme mx-1'
            onClick={() => Navigate(`${item.id}/AssetsDetails`)}
          >
            <i className='far fa-lg fa-fw fa-edit'></i>
          </button>

          {/* زر المشاهدة */}
          <button
            type='button'
            className='btn  btn-outline-primary mx-1'
            onClick={() => Navigate(`${item.id}/AssetsDetails`)}
          >
            <i className='far fa-lg fa-fw fa-eye'></i>
          </button>

          {/* زر الحذف */}
          <button type='button' className='btn  btn-outline-danger mx-1'>
            <i className='far fa-lg fa-fw fa-trash-alt'></i>
          </button>
        </div>
      )
    };
  });

  //________________________________________________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'الأصـول',
              link: null
            }
          ]}
          PageName='الأصــول'
        />

        <div className='ms-auto'>
          <Link
            to=''
            // to="AddAssets"
            className='btn me-1 btn-theme'
            onClick={() => setShowAddModal(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            إضـافة أصل جديـد
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal
        show={showAddModal}
        setShow={setShowAddModal}
        // bodyClassName="p-0"
        title='إضـافة أصل جديـد'
        size='xl'
        // showHeader={false}
      >
        <Add onClose={() => setShowAddModal(false)} />
      </NeatixModal>
    </div>
  );
};

export default Index;
